import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

/**
 * Helper component to render label with info icon tooltip
 */
export const LabelWithInfo: React.FC<{
  label: string;
  description?: string;
  required?: boolean;
}> = ({ label, description, required }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <span style={{ fontWeight: 600 }}>
      {label}
      {required && <span style={{ color: 'red' }}> *</span>}
    </span>
    {description && (
      <Tooltip title={description} arrow>
        <InfoIcon sx={{ fontSize: '16px', color: '#999999', cursor: 'help' }} />
      </Tooltip>
    )}
  </Box>
);
